<template>
  <div class="client application-tracker quick-action-toolbar" v-if="isManager">
    <div :class="{ 'show-on-hover': onHover }">
      <v-toolbar :flat="onHover" dense :color="color">
        <v-toolbar-items v-if="candidate.status !== 'Unsuccessful'">
          <v-menu v-model="regretting" max-width="180" height="200" top attach>
            <v-btn
              slot="activator"
              class="red darken-3"
              dark
              @click.stop="regretting = true"
            >
              <v-icon>mdi-account-off</v-icon>
            </v-btn>
            <v-card>
              <v-card-text>
                You are about to <strong>Regret</strong>
                {{ candidate.profile.firstName }}
                {{ candidate.profile.lastName }}
              </v-card-text>
              <v-card-actions>
                <v-layout column align-center>
                  <v-btn flat block @click="regretting = false">Cancel</v-btn>
                  <v-btn
                    block
                    :color="themes.client.light.primaryActionButton"
                    @click="regret"
                  >
                    Regret
                  </v-btn>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-toolbar-items>

        <v-spacer />

        <v-toolbar-items>
          <v-menu
            top
            left
            max-width="300"
            max-height="300"
            attach
            v-model="showEventsList"
          >
            <v-btn flat slot="activator" @click.stop="showEventsList = true">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
            <ApplicationEventsList
              :opportunity="opportunity"
              :applications="selected[0] ? selected : candidate"
              @done="$emit('done', $event)"
            />
          </v-menu>
          <v-menu
            v-if="nextPhase"
            v-model="advancing"
            left
            top
            max-width="200"
            attach
          >
            <v-btn
              slot="activator"
              @click.stop="advancing = true"
              class="green darken-3"
              block
              flat
              dark
            >
              <v-icon>mdi-forward</v-icon>
            </v-btn>

            <v-card>
              <v-card-text>
                You are about to advance {{ candidate.profile.firstName }}
                {{ candidate.profile.lastName }} to
                <strong>{{ nextPhase.name }}</strong>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn flat @click="advancing = false">Cancel</v-btn>
                <v-btn
                  :color="themes.client.light.primaryActionButton"
                  @click="advance"
                >
                  Advance
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-toolbar-items>
      </v-toolbar>
    </div>
  </div>
</template>

<script>
// Components
import ApplicationEventsList from "@/components/client/applications/ApplicationEventsList";

// Helpers
import _ from "lodash";

export default {
  props: {
    candidate: Object,
    onHover: { type: Boolean, default: false },
    color: { type: String, default: "white" }
  },

  components: { ApplicationEventsList },

  data() {
    return {
      advancing: false,
      regretting: false,
      showEventsList: false
    };
  },
  computed: {
    selected() {
      return this.$store.getters["client/applications/selected"];
    },

    opportunity() {
      const id =
        _.get(this, "candidate.opportunity.id") || this.$route.params.id;
      return this.$store.getters["client/opportunities/find"](id);
    },

    open() {
      if (!this.opportunity) return false;

      return (
        new Date(this.opportunity.closesAt) > new Date() &&
        new Date(this.opportunity.publishedAt) < new Date()
      );
    },

    orderedPhases() {
      return this.$store.getters["client/opportunities/orderedPhases"]();
    },

    nextPhase() {
      const current = this.orderedPhases.indexOf(
        this.orderedPhases.find(p => p.name === this.candidate.status)
      );
      if (current >= 0 && this.orderedPhases[current + 1]) {
        return this.orderedPhases[current + 1];
      } else {
        return "";
      }
    },

    isManager() {
      const id = _.get(this, "opportunity.id") || this.$route.params.id;
      return this.$store.getters["client/opportunities/currentIsManager"](id);
    }
  },
  methods: {
    async advance() {
      if (!this.isManager) return;

      if (this.advancing) {
        this.hide = true;
        const dispatch = this.$store.dispatch;

        await dispatch("client/applications/move", {
          applications: this.candidate,
          phase: this.nextPhase
        }).then(
          () => dispatch("snackbarSuccess", "Advanced successfully"),
          () => dispatch("snackbarError", "No application was moved")
        );
        this.advancing = false;
        this.$emit("done", this.newPhase);
        return dispatch("client/applications/updateFilters", {});
      }
    },

    async regret() {
      if (!this.isManager) return;

      if (this.regretting) {
        const dispatch = this.$store.dispatch;

        await dispatch("client/applications/regret", {
          applications: this.candidate
        }).then(
          () => dispatch("snackbarSuccess", "Regretted"),
          () => dispatch("snackbarError", "Error: No change was made")
        );
        this.$emit("done");
        this.regretting = false;
        return dispatch("client/applications/updateFilters", {});
      }
    }
  }
};
</script>

<style>
.client.application-tracker.quick-action-toolbar {
  width: 100%;
}
.client.application-tracker.quick-action-toolbar nav div.v-toolbar__content {
  padding: 0;
  margin-top: -48px;
}

.client.application-tracker.quick-action-toolbar:hover div.show-on-hover {
  opacity: 1;
}

.client.application-tracker.quick-action-toolbar div.show-on-hover {
  position: absolute;
  width: 100%;
  opacity: 0;
}
</style>
